import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import type { Billing } from '../../types/pricing';
type BillingToggleProps = {
  value: Billing;
  onChange: (value: Billing) => void;
};
const options: {
  id: Billing;
  label: string;
}[] = [{
  id: 'monthly',
  label: 'Monthly'
}, {
  id: 'annual',
  label: 'Annual'
}];
export function BillingToggle({
  value,
  onChange
}: BillingToggleProps) {
  const reduceMotion = useReducedMotion();
  return <div role="radiogroup" aria-label="Billing period" className="inline-flex items-center rounded-[10px] border border-canvas-line bg-white p-1" data-id="element-922" data-mp="gq7k4wqrq120">
      {options.map(option => {
      const active = value === option.id;
      return <button key={option.id} type="button" role="radio" aria-checked={active} onClick={() => onChange(option.id)} className={`relative flex items-center gap-2 rounded-[7px] px-4 py-2 text-[14px] font-semibold transition-colors duration-150 ease-out ${active ? 'text-white' : 'text-ink hover:text-ink-muted'}`} data-id="element-923" data-mp="lqmvxjvej0hv">
            {active && <motion.span layoutId="billing-pill" transition={reduceMotion ? {
          duration: 0
        } : {
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="absolute inset-0 rounded-[7px] bg-ink" aria-hidden="true" data-id="element-924" data-mp="1x1s4w349syuo" />}
            <span className="relative" data-id="element-925" data-mp="19bxvjvj5tsf6">{option.label}</span>
            {option.id === 'annual' && <span className={`relative rounded-full px-2 py-0.5 text-[11px] font-semibold ${active ? 'bg-brand text-white' : 'bg-brand-soft text-brand'}`} data-id="element-926" data-mp="1ebk780jcb0lv">
                Save 20%
              </span>}
          </button>;
    })}
    </div>;
}